class Category {
    constructor(object) {
        Object.keys(object).forEach(key => {
            this[key] = object[key]
        })
    }
}

export default Category
